import { motion } from "framer-motion";
import { SWATCHES } from "../lib/constants";

const SWATCH_IMG =
  "https://static.prod-images.emergentagent.com/jobs/f356e486-2013-43a6-a960-a50c27505bc4/images/e0a85cc6875cb3d77cbdae0036f7447100b82f1a2aed5c9fca8a31d5fac59674.png";

const STATS = [
  { num: "80+", label: "Successful projects" },
  { num: "16", label: "Years on the brush" },
  { num: "94+", label: "Melbourne suburbs served" },
  { num: "4.9", label: "Average rating" },
];

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-20 md:py-32 px-5 md:px-10 lg:px-16"
    >
      <div className="grid grid-cols-12 gap-6">
        <div className="col-span-12 md:col-span-5 lg:col-span-4">
          <p className="section-num mb-3">01 — About</p>
          <h2 className="font-display text-5xl md:text-6xl lg:text-7xl uppercase leading-[0.9] tracking-tighter">
            We don't just<br />paint walls.<br />
            <span className="text-[#D85C3A]">We finish</span><br />stories.
          </h2>
        </div>

        <div className="col-span-12 md:col-span-7 lg:col-span-5 md:pt-20">
          <p className="text-lg leading-relaxed mb-6">
            The Melbourne Painters is a Melbourne-born outfit run by Gurdeep — a hands-on
            tradesman who still walks every job before, during and after. We cater to all
            sorts of interior and exterior painting work across residential and commercial
            properties. Pricing is competitive. Workmanship is not.
          </p>
          <p className="text-base leading-relaxed text-[#444]">
            From a single bedroom refresh in Carlton to a full Edwardian restoration in
            Toorak, every job goes through the same five-step process: consult, prep,
            sample, apply, and walkthrough. Nothing leaves until you've signed it off.
          </p>

          <div className="grid grid-cols-2 gap-4 mt-10">
            {STATS.map((s, i) => (
              <motion.div
                key={s.label}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className="border-2 border-[#111] p-5 bg-[#F2F2EF]"
                data-testid={`stat-${s.label.toLowerCase().replace(/\s/g, '-')}`}
              >
                <div className="font-display text-5xl md:text-6xl text-[#111]">{s.num}</div>
                <div className="text-xs uppercase tracking-widest text-[#666] mt-1">{s.label}</div>
              </motion.div>
            ))}
          </div>
        </div>

        <div className="col-span-12 md:col-span-12 lg:col-span-3 flex flex-col gap-4">
          <div className="border-2 border-[#111] aspect-[3/4] overflow-hidden shadow-brut">
            <img src={SWATCH_IMG} alt="Melbourne painter colour swatches and paint chips for interior consultation" className="w-full h-full object-cover" loading="lazy" decoding="async" width="600" height="800" />
          </div>
          <div className="grid grid-cols-4 gap-1.5">
            {SWATCHES.map((s) => (
              <div
                key={s.name}
                className="swatch-tile aspect-square border-2 border-[#111]"
                style={{ background: s.hex }}
                title={s.name}
                data-testid={`swatch-${s.name.toLowerCase().replace(/\s/g, '-')}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
